import { DependencyList, useEffect, useState } from "react";

export default function useAsyncMemo<R>(
  loadFn: () => Promise<R>,
  deps: DependencyList
): [R | undefined, boolean] {
  const [result, setResult] = useState<R | undefined>(undefined);
  const [isChecking, setIsChecking] = useState(false);

  useEffect(() => {
    let active = true;

    const load = async () => {
      setIsChecking(true);
      const res = await loadFn();
      setIsChecking(false);
      if (active) {
        setResult(res);
      }
    };

    load();

    return () => {
      active = false;
      setIsChecking(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return [result, isChecking];
}
